export const baiduTriggerEvent = (data) => {
  window.baidu && window.baidu.trigger && window.baidu.trigger(data);
};



// WEBPACK FOOTER //
// ./src/utils/baiduTriggerEvent.js